import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/Login.vue'
import TTT from './views/ttt.vue'
import Manager from './views/Manager'
import MediaList from './views/MediaList.vue'
import WeMediaList from './views/WeMediaList.vue'
import ModificationList from './views/ModificationList.vue'
import ManuscriptList from './views/ManuscriptList.vue'
import Myquestion from './views/Myquestion.vue'
import DetailedList from './views/DetailedList.vue'
import MymediaList from './views/MymediaList.vue'
import RechargeList from './views/RechargeList.vue'
import AddArticle from './views/AddArticle.vue'
import BalanceRecharge from './views/BalanceRecharge.vue'
import MyData from './views/MyData.vue'
import OrderList from './views/OrderList.vue'
import Chooersmedia from './views/Chooersmedia.vue'
import BolgPublish from './views/publish/BolgPublish.vue'
import mediaPublish from './views/publish/mediaPublish.vue'
import OfficalPublish from './views/publish/OfficalPublish.vue'
import SelfPublish from './views/publish/SelfPublish.vue'
import TiktokPublish from './views/publish/TiktokPublish.vue'
import WechatPublish from './views/publish/WechatPublish.vue'
import WikiPublish from './views/publish/WikiPublish.vue'
import Pay from './views/Pay.vue'
import Withdrawal from './views/Withdrawal.vue'
import Withdrawalfx from './views/withdrawalfx.vue'
import myfxusers from './views/myfxusers.vue'
import myfx from './views/myfx.vue'
import Look from './views/Look.vue'
import Look2 from './views/Look2.vue'
import Register from './views/Register.vue'//
import Information from './views/Information.vue'
import newAdd from './views/newAdd.vue'
import TransferList from './views/TransferList.vue'
import TransferListfx from './views/transferListfx.vue'
import MustKnow from './views/MustKnow.vue'
import MyOtherMedia from './views/MyOtherMedia.vue'
import Preview from './views/Preview.vue'
import ChangePhone from './views/ChangePhone.vue'
// changePhone 
Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [{
      path: '/',
      component: Login
    },
    {
      path: '/manager',
      component: Manager,
      name: '',
      children: [{
          path: '',
          component: MediaList,
          meta: [],
        },
        ,
    {
      path: '/information',
      component: Information,
      meta: ['首页', '平台信息'],

    },//
    {
      path: '/chooersmedia',
      component: Chooersmedia,
      meta: ['文章管理', '文章发布'],
    },
    {
      path: '/BolgPublish',
      component: BolgPublish,
      meta: ['文章管理', '文章发布', '微博'],
    },
    {
      path: '/mediaPublish',
      component: mediaPublish,
      meta: ['文章管理', '文章发布', '媒体资源'],
    },
    {
      path: '/OfficalPublish',
      component: OfficalPublish,
      meta: ['文章管理', '文章发布', '微信公众号资源'],
    },
    {
      path: '/SelfPublish',
      component: SelfPublish,
      meta: ['文章管理', '文章发布', '自媒体'],
    },
    {
      path: '/TiktokPublish',
      component: TiktokPublish,
      meta: ['文章管理', '文章发布', '短视频资源'],
    },

        {
      path: '/WechatPublish',
      component: WechatPublish,
      meta: ['文章管理', '文章发布', '朋友圈社群'],
    },
    {
      path: '/WikiPublish',
      component: WikiPublish,
      meta: ['文章管理', '文章发布', '百科资源'],
    },

    
        // 媒介所WeMediaListChooerswemedia
        {
          path: '/wemediaList',
          component: WeMediaList,
          meta: ['文章管理', '自媒体'],
        },
        {
          path: '/mediaList',
          component: MediaList,
          meta: ['文章管理', '媒体资源'],
        },
        {
          path: '/manuscriptList',
          component: ManuscriptList,
          meta: ['文章管理', '稿件管理'],
        },
        {
          path: '/myquestion',
          component: Myquestion,
          meta: ['文章管理', '修改订单'],
        }, {
          path: '/addArticle',
          component: AddArticle,
          meta: ['文章管理', '文章发布'],
        },
        {
          path: '/modificationList',
          component: ModificationList,
          meta: ['媒介订单', '订单修改'],
        },
        {
          path: '/orderList',
          component: OrderList,
          meta: ['媒介订单', '我的订单'],
        },
        {
          path: '/myData',
          component: MyData,
        },
        {
          path: '/changePhone',
          component: ChangePhone,
        },
        {
          path: '/rechargeList',
          component: RechargeList,
        },
        {
          path: '/transferList',
          component: TransferList,
        },
        {
          path: '/transferListfx',
          component: TransferListfx,
        },
        {
          path: '/detailedList',
          component: DetailedList,
        },
        {
          path: '/balanceRecharge',
          name:"balanceRecharge",
          component: BalanceRecharge,
        },
        {
          path: '/newadd',
          component: newAdd,
        },       
        {
          path: '/mymediaList',
          component: MymediaList,
          meta: ['我的媒体', '媒体管理'],
        },
        {
          path: '/myothermedia',
          component: MyOtherMedia,
          meta: ['我的媒体', '媒体审核'],
        },
        {
          path: '/withdrawal',
          component: Withdrawal,
          meta: ['我的媒体', '媒体收益'],
        },
        {
          path: '/withdrawalfx',
          component: Withdrawalfx,
          meta: ['一起推', '分销收益'],
        },
        {
          path: '/myfxusers',
          component: myfxusers,
          meta: ['一起推', '我的分销用户'],
        },
        {
          path: '/myfx',
          component: myfx,
          meta: ['一起推', '我的分销'],
        },
        // 
      ]
    },
    {
      path: '/pay',
      component: Pay,
      meta: ['支付', '支付宝']
    },
    {
      path: '/look',
      name:"look",
      component: Look,
      meta: ['预览', '文章']
    },
    {
      path: '/look2',
      name:"look2",
      component: Look2,
      meta: ['预览', '文章']
    },
    {
      path: '/register',
      component: Register
    } ,
    {
      path: '/mustknow',
      name:"mustknow",
      component: MustKnow,
    },
    {
      path: '/preview',
      name:"preview",
      component: Preview,
    }
  ]
})